export default {
  banner: {
    code: 'Specific identifier for target a banner',
    name: 'Title of the banner',
    status: 'Banner status, the banner is either enabled or disabled',
    content: 'Banner content, you can generate content for the language of your choice',
    ctatext: 'Ctatext content, you can generate ctatext for the language of your choice',
    ctalink: 'ctalink is a dedicated field with no write restrictions',
    ctaonclick: 'ctaonclick is a dedicated field with no write restrictions',
    url: 'The url will allow to locate the place where to implement the banner',
    url_target: 'the url_target will be a regex set up to target the url more easily',
    frequencylimitation: 'frequencylimitation will allow us to know how often we should display the banner',
    frequencylimitationvalue: 'frequencylimitationvalue is a value of which will tell us the display frequency => 1 for one time',
    activationdate: 'Date when the banner will start to be displayed',
    deactivationdate: 'Date when the banner will end to be displayed'
  }
}



// WEBPACK FOOTER //
// ./src/translations/en/tooltip.js